import React from 'react';
import { Box, Typography } from '@mui/material';
import { UserAvatar } from '../common/UserAvatar.tsx';

interface ChatToastProps {
  title: string;
  body: string;
  avatar?: string;
}

export const ChatToast: React.FC<ChatToastProps> = ({ title, body, avatar }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
      <Box sx={{ mr: 1.5, flexShrink: 0 }}>
        <UserAvatar 
          name={title} 
          path={avatar} 
          sx={{ width: 40, height: 40 }} 
        />
      </Box>
      <Box sx={{ minWidth: 0, flexGrow: 1 }}>
        <Typography 
          variant="subtitle2" 
          sx={{ 
            fontWeight: 600, 
            lineHeight: 1.2,
            mb: 0.5 
          }}
        >
          {title}
        </Typography>
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{ 
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'block',
            maxWidth: '200px' // Обмеження ширини для довгих повідомлень
          }}
        >
          {body}
        </Typography>
      </Box>
    </Box>
  );
};
